<app-navbar-cmp></app-navbar-cmp>
<div class="wrapper">

  <div class="page-header page-header-mini">
    <div class="page-header-image" data-parallax="true" style="background-image: url('assets/projects/project_header.jpg');">
    </div>
  </div>
  <div class="main">
    <router-outlet></router-outlet>

    <footer class="footer footer-big" data-background-color="black">
      <div class="container">
        <div class="content">
          <div class="row">
            <div class="col-md-4">
              <h5>About Us</h5>
              <p>PetaMedia merupakan bagian dari PetaRumah yang memiliki komitmen untuk menggerakkan industri properti Indonesia ke arah yang lebih modern melalui fotografi dan teknologi media kreatif yang menarik. </p>
              <p>"Photography is a language that everyone can understand. That's why we don't shoot what it looks like. We shoot what it feels like." </p>
            </div>
            <div class="col-md-4">
              <h5>Contact Us</h5>
              <div class="social-feed">
                <div class="feed-line">
                  <i class="fab fa-whatsapp"></i>
                  <p>0812 6500 1988</p>
                </div>
                <div class="feed-line">
                  <p>team@petarumah.com</p>
                </div>
                <div class="feed-line">
                  <p>Jalan Yos Sudarso Komplek Brayan One Stop Square No. 8AQ, Medan Timur, Sumatera Utara, Indonesia - 20235</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <h5>Instagram Feed</h5>
              <!--<div class="gallery-feed">
                <img src="assets/img/olivia.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/james.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/michael.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/emily.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/marie.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/usher.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/mike.jpg" class="img img-raised rounded" alt="" />
                <img src="assets/img/julie.jpg" class="img img-raised rounded" alt="" />
              </div>-->
            </div>
          </div>
        </div>
        <hr />
        <ul class="pull-left">
          <li>
            <a href="https://petarumah.com" target="_blank">
              PetaRumah
            </a>
          </li>
          <li>
            <a href="https://petarumah.com/about-us" target="_blank">Team PetaRumah</a>
          </li>
          <li>
            <a href="https://www.instagram.com/petarumah/" target="_blank">Instagram</a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCmBtvsu-OO96_x28nRItoHA" target="_blank">Youtube</a>
          </li>
          <!--<li>
            <a href="#pablo">
              Blog
            </a>
          </li>
          <li>
            <a href="#pablo">
              Presentation
            </a>
          </li>
          <li>
            <a href="#pablo">
              Discover
            </a>
          </li>
          <li>
            <a href="#pablo">
              Payment
            </a>
          </li>
          <li>
            <a href="#pablo">
              Contact Us
            </a>
          </li>-->
        </ul>
        <div class="copyright pull-right">
          Copyright &copy;
          {{ getFullYear() }} PetaRumah All Rights Reserved.
        </div>
      </div>
    </footer>
  </div>
</div>
